__turbopack_context__.v({
  "black": "BuyWithUs-module-scss-module__XtNNja__black",
  "card": "BuyWithUs-module-scss-module__XtNNja__card",
  "cardDescription": "BuyWithUs-module-scss-module__XtNNja__cardDescription",
  "cardTitle": "BuyWithUs-module-scss-module__XtNNja__cardTitle",
  "decor1": "BuyWithUs-module-scss-module__XtNNja__decor1",
  "decor2": "BuyWithUs-module-scss-module__XtNNja__decor2",
  "decoration": "BuyWithUs-module-scss-module__XtNNja__decoration",
  "fade-in-up": "BuyWithUs-module-scss-module__XtNNja__fade-in-up",
  "fadeInUp": "BuyWithUs-module-scss-module__XtNNja__fadeInUp",
  "gray": "BuyWithUs-module-scss-module__XtNNja__gray",
  "grid": "BuyWithUs-module-scss-module__XtNNja__grid",
  "image": "BuyWithUs-module-scss-module__XtNNja__image",
  "light": "BuyWithUs-module-scss-module__XtNNja__light",
  "mobile": "BuyWithUs-module-scss-module__XtNNja__mobile",
  "orange": "BuyWithUs-module-scss-module__XtNNja__orange",
  "red": "BuyWithUs-module-scss-module__XtNNja__red",
  "title": "BuyWithUs-module-scss-module__XtNNja__title",
});
